import React, { useEffect } from "react";
import "./Header.css";
import images from "../../../../utilities/images/images";
import { useHistory, useLocation } from "react-router-dom";
import {
  buildYearWiseListingPath,
  getYearFromListingLocation,
  goBackFromPracticePage,
  persistSelectedPyqYear,
  readPersistedPyqYear,
} from "../../../../custom_utilities/dashboardBannerNavigation";
import { useDispatch, useSelector } from "react-redux";
import {
  getPyqYearWiseRequest,
  setSelectedPyqYear,
} from "../../../../redux/exam/examSlice";
import { fetchAitsTestListRequest } from "../../../../redux/aits/aitsSlice";
import { getFormatForApi } from "../../../../custom_utilities/pyqFormatUtils";

const resolvePreferredPyqYear = (years, candidates) => {
  const yearNumbers = (years || [])
    .map((item) => Number(item?.year))
    .filter((year) => Number.isFinite(year));

  for (const candidate of candidates) {
    const year = Number(candidate);
    if (Number.isFinite(year) && yearNumbers.includes(year)) {
      return year;
    }
  }

  return yearNumbers.length ? Math.max(...yearNumbers) : null;
};

const Header = () => {
  const navigate = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    pyqYears,
    selectedPyqYear,
    selectedType,
    paperName,
    plannerDetails,
    testDetails,
  } = useSelector((state) => state.examSlice);

  const plannerId = plannerDetails?.planner_id;
  const plannerTypeId = plannerDetails?.planner_type_id;
  const paperType = plannerDetails?.id;
  const categoryId = plannerDetails?.category_id;
  const isMistakeBook = String(paperName || "")
    .toLowerCase()
    .includes("mistake book");

  const pyqFormatForApi = getFormatForApi({
    format: selectedType,
    paperName,
    selectedType,
  });

  /* -------- Fetch year list -------- */
  useEffect(() => {
    if (isMistakeBook) return;
    if (plannerDetails?.type === "year wise") {
      dispatch(
        getPyqYearWiseRequest(
          pyqFormatForApi ? { topic: pyqFormatForApi } : {}
        )
      );
    }
  }, [dispatch, plannerDetails?.type, pyqFormatForApi, paperName, isMistakeBook]);

  /* -------- Restore the year the user was on, else latest -------- */
  useEffect(() => {
    if (isMistakeBook) return;
    if (plannerDetails?.type !== "year wise") return;
    if (!pyqYears?.length) return;

    const preferredYear = resolvePreferredPyqYear(pyqYears, [
      getYearFromListingLocation(location),
      location.state?.year,
      testDetails?.year,
      readPersistedPyqYear(),
      selectedPyqYear,
    ]);

    if (preferredYear == null) return;

    if (String(selectedPyqYear) !== String(preferredYear)) {
      dispatch(setSelectedPyqYear(preferredYear));
    }
    persistSelectedPyqYear(preferredYear);

    dispatch(
      fetchAitsTestListRequest({
        paperType,
        plannerId,
        plannerTestType: plannerTypeId,
        year: preferredYear,
        ...(pyqFormatForApi ? { format: pyqFormatForApi } : {}),
        categoryId: categoryId || "",
      })
    );

    const urlYear = new URLSearchParams(location.search).get("year");
    if (String(urlYear || "") !== String(preferredYear)) {
      const listingPath = buildYearWiseListingPath(preferredYear);
      const query = listingPath.includes("?")
        ? listingPath.slice(listingPath.indexOf("?"))
        : "";
      navigate.replace({
        pathname: location.pathname,
        search: query,
        state: { ...(location.state || {}), year: preferredYear },
      });
    }
    // Restore once when the year list arrives; URL / test details supply the year.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pyqYears, isMistakeBook, plannerDetails?.type]);
  const handleBackClick = () => {
    // Mistake Book must stay in its own flow — never paper-listing.
    if (isMistakeBook) {
      navigate.push("/practice/mistake-book");
      return;
    }
    goBackFromPracticePage(navigate, location);
  };

  const handleYearChange = (e) => {
    if (isMistakeBook) return;
    const year = e.target.value;
    dispatch(setSelectedPyqYear(year));
    persistSelectedPyqYear(year);

    dispatch(
      fetchAitsTestListRequest({
        paperType,
        plannerId,
        plannerTestType: plannerTypeId,
        year,
        ...(pyqFormatForApi ? { format: pyqFormatForApi } : {}),
        categoryId: categoryId || "",
      })
    );

    const listingPath = buildYearWiseListingPath(year);
    navigate.replace({
      pathname: location.pathname,
      search: listingPath.includes("?")
        ? listingPath.slice(listingPath.indexOf("?"))
        : "",
      state: { ...(location.state || {}), year },
    });
  };

  return (
    <div className="aits_header">
      <div
        className="aits_header_left"
        onClick={handleBackClick}
        style={{ cursor: "pointer" }}
      >
        <img className="back_icon" src={images.new_backarrow} alt="backbtn" />
        {/* <div>{paperName}</div> */}
      </div>
      <div className="aits_header_center">{paperName}</div>
      {!isMistakeBook && plannerDetails?.type === "year wise" && (
        <div className="aits_header_right">
          <select
            className="pyq_dropdown"
            value={selectedPyqYear || ""}
            onChange={handleYearChange}
          >
            {pyqYears?.map((y) => (
              <option key={y.year} value={y.year}>
                {y.year}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default Header;
